import React, { FunctionComponent } from 'react'
import Box from '@material-ui/core/Box'
import { ReservationsProvider } from 'components/views/reservations/ReservationsProvider'
import Message, { MessageProvider } from 'components/elements/Message'
import Toolbar from 'components/views/reservations/partials/Toolbar'
import List from 'components/views/reservations/partials/List'

export type Props = {}
export type Functions = {}
export type AllProps = Props & Functions

const Reservations: FunctionComponent<AllProps> = ({}) => {
  return (
    <Box p={1.5}>
      <ReservationsProvider>
        <MessageProvider>
          <Toolbar />
          <List />
          <Message />
        </MessageProvider>
      </ReservationsProvider>
    </Box>
  )
}

export default Reservations
